// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'bootstrap/dist/css/bootstrap.min.css'

Vue.use(VueResource)
Vue.use(Element)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})

window.AV = require('leancloud-storage')
const Valine = require('valine')
new Valine({
  el: '#vcomments',
  appId: 'hewIB5JPfodYOSevWzIaytVK-gzGzoHsz',
  appKey: 'j1Rg5eeaT8Ruk89gaQPItvWU',
  notify: false,
  verify: false,
  avatar: 'mm',
  placeholder: '老板留个言呗？'
})



// WEBPACK FOOTER //
// ./src/main.js